import { NavLink, Outlet } from "react-router-dom";
import clsx from "clsx";
import { UploadSocketProvider } from "@/contexts/UploadSocketContext";

export interface TabItem {
  to: string;
  label: string;
  end?: boolean;
}

interface ModuleLayoutProps {
  title: string;
  tabs: TabItem[];
  wsPath?: string;
  wsSuccessMessage?: string;
}

export const ModuleLayout = ({
  title,
  tabs,
  wsPath,
  wsSuccessMessage,
}: ModuleLayoutProps) => {
  const content = (
    <div className="space-y-6">
      <div className="border-b border-slate-200 pb-3">
        <nav className="flex items-center gap-1.5" aria-label={`Navegación de ${title}`}>
          {tabs.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                clsx(
                  "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-accent-blue/15 text-accent-blue font-semibold"
                    : "text-ink-secondary hover:bg-slate-100",
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );

  if (wsPath) {
    return (
      <UploadSocketProvider path={wsPath} successMessage={wsSuccessMessage}>
        {content}
      </UploadSocketProvider>
    );
  }

  return content;
};
